import React from 'react';
import { Box, SelectChangeEvent } from '@mui/material';
import { NewFromSelectField } from '../../../../presentation';
import { Option } from '@converge/graphql';

export interface DiaryAssigneeDropdownProps {
  taskId: string;
  options: { value: string | null | undefined; label: string }[];
  onChange?: (taskId: string, value: string) => void;
  hideBorders?: boolean;
  disabled?: boolean;
  isNotActive?: boolean;
  onUpdateTaskOwner: (
    event: SelectChangeEvent<unknown>,
    taskUuid: string
  ) => void | Promise<void>;
}

export const DiaryAssigneeDropdown = ({
  taskId,
  options,
  onChange,
  disabled,
  isNotActive,
  onUpdateTaskOwner,
}: DiaryAssigneeDropdownProps) => {
  const handleChangeOption = React.useCallback(
    (selectedOption: Option | null) => {
      const newValue = selectedOption ? (selectedOption.value as string) : null;

      // Create a synthetic event for the API handler
      const syntheticEvent = {
        target: { value: newValue },
      } as SelectChangeEvent<unknown>;

      // Call the API handler - the form state is already handled by NewFromSelectField's Controller
      onUpdateTaskOwner(syntheticEvent, taskId);
    },
    [taskId, onUpdateTaskOwner]
  );

  return (
    <Box className="assignee-dropdown-wrapper" sx={{ marginRight: '10px' }}>
      <NewFromSelectField
        name={`assignee-${taskId}`}
        className="task-owner"
        options={options}
        hideLabel
        hideBorders={false}
        onChangeOption={handleChangeOption}
        disabled={disabled}
        sx={{
          width: '160px',
          zIndex: 0,
          position: 'relative',
          // Make it look slightly disabled if needed
          opacity: disabled ? 0.7 : 1,

          '.MuiOutlinedInput-root': {
            backgroundColor: 'white',
            height: '37px',
            '& fieldset': {
              borderColor: '#666666',
            },
            '&:hover fieldset': {
              borderColor: '#666666',
            },
            '&.Mui-focused fieldset': {
              borderColor: '#23a892',
            },
            '&.Mui-disabled fieldset': {
              borderColor: ` ${
                isNotActive ? 'rgba(131, 130, 130, 0.55)' : '#939292ff'
              }`,
            },

            '&.Mui-disabled .MuiSelect-select': {
              color: isNotActive ? 'rgba(131, 130, 130, 0.55)' : '#939292ff',
              '-webkit-text-fill-color': isNotActive
                ? 'rgba(131, 130, 130, 0.55)'
                : '#939292ff',
            },

            '& .MuiSelect-select': {
              paddingLeft: '7px !important',
            },
          },
        }}
      />
    </Box>
  );
};

export default DiaryAssigneeDropdown;
